'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = createConverter;

var _cachedValue = require('./cachedValue');

function createConverter() {
    var replacements = [[/\?/g, '<Q>'], [/\*/g, '<A>'], [/!/g, '<E>'], [/\$/g, '<D>'], [/\(/g, '<O>'], [/\\/g, '<B>'], [/\)/g, '<C>'], [/\+/g, '<P>'], [/\^/g, '<X>'], [/\|/, '<I>'], [/,/g, '<M>'], [/\./g, '<F>'], [/\[/g, '<S>'], [/]/g, '<R>'], [/À|Á|Â|Ã|Ä|Å|à|á|â|ã|ä|å/g, 'A'], [/Æ|æ/g, 'A,E'], [/Ç|ç/g, 'C'], [/È|É|Ê|Ë|è|é|ê|ë/g, 'E'], [/Ì|Í|Î|Ï|ì|í|î|ï/g, 'I'], [/Ð|ð/g, 'D,H'], [/Ò|Ó|Ô|Õ|Ö|ò|ó|ô|õ|ö|ø/g, 'O'], [/Ù|Ú|Û|Ü|ù|ú|û|ü/g, 'U'], [/Ý|ý|ÿ|Ÿ/g, 'Y'], [/Ñ|ñ/g, 'N'], [/Ø|ø/g, 'O'], [/Þ|þ/g, 'T,H'], [/ß/g, 'S,S'], [/[a-z]/g, function (item) {
        return item.toUpperCase();
    }], [/[\u0000-\u001f]/g, ' ']];
    var prepareReplacement = function prepareReplacement(_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            regex = _ref2[0],
            value = _ref2[1];

        return function (item) {
            return item.replace(regex, value);
        };
    };
    var replaceActions = replacements.map(prepareReplacement);
    var topicDictionary = (0, _cachedValue.dictionary)(function (value) {
        return replaceActions.reduce(function (result, replaceAction) {
            return replaceAction(result);
        }, value);
    });

    return {
        /**
         * convert from topic
         */
        from: topicDictionary.getKey,
        /**
         * convert to topic
         */
        to: topicDictionary.getValue
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/topicConverter.js
// module id = 1387
// module chunks = 1